module.exports = __webpack_public_path__ + "static/media/bedQuestion.6dd348ec.png";